module.exports = __webpack_public_path__ + "img/Select.1f1ca1d0.svg";